import type { Track } from "@/types/types";
import { getAccess } from "./api";
import { offlineUrl } from "./offline";

export function streamUrl(track: Track, opts: { codec?: string; bitrate?: number } = {}): string {
  const codec = opts.codec ?? "opus";
  const bitrate = opts.bitrate ?? 192;
  const token = getAccess();
  const q = new URLSearchParams({ codec, bitrate: String(bitrate) });
  if (token) q.set("token", token);
  return `/api/stream/${track.id}?${q.toString()}`;
}

// Prefer an offline-saved blob when the user marked the track for offline;
// falls back to the streaming URL. The JWT rides in the query string because
// <audio src> can't set Authorization headers.
export async function assignSourceToAudio(audio: HTMLAudioElement, track: Track): Promise<void> {
  const offline = await offlineUrl(track.id).catch(() => null);
  audio.src = offline ?? streamUrl(track);
  audio.load();
}
